import { render, staticRenderFns } from "./ModuleBlock.vue?vue&type=template&id=066d876a"
import script from "./ModuleBlock.vue?vue&type=script&lang=js"
export * from "./ModuleBlock.vue?vue&type=script&lang=js"
import style0 from "./ModuleBlock.vue?vue&type=style&index=0&id=066d876a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports